export const colors = {
  primaryColor : "#08d8de",
  secondaryColor : "#001a29",
  textWithWhiteBg : "#181818",
  textWithPrimaryColorBg : "#181818",
  linearGradient :
"linear-gradient(107deg,rgba(0,0,0,.6),rgba(0,0,0,.6) 29.64%,rgba(9,216,222,.36) 63.22%,rgba(9,216,222,.6) 100.44%)",
darkColor:"#039094"
}